import {NgModule} from '@angular/core';
import {SharedModule} from '../../../shared/shared.module';
import { MobileFacaParteComponent } from './mobile-faca-parte/mobile-faca-parte.component';
import {PropostaModule} from '../proposta.module';
import { MobileEtapaEmailComponent } from './mobile-etapa-email/mobile-etapa-email.component';

@NgModule({
    imports: [SharedModule, PropostaModule],
    providers: [],
    declarations: [MobileFacaParteComponent, MobileEtapaEmailComponent],
    exports: [MobileFacaParteComponent, MobileEtapaEmailComponent],
})
export class MobilePropostaModule {}
